<i18n
  src="@/locales/views/organization/certifications/basic_certifications_producers/list_producers.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/crop_field_certification.yml" lang="yaml"></i18n>
<template>
  <div v-if="typeof days_until_expiration_date == 'number'">
    <span class="text-red-500" v-if="days_until_expiration_date < 0">
      <i class="fa-solid fa-triangle-exclamation text-red-500"></i>
      {{ $t("model.crop_field_certification.expired") }}
    </span>
    <span v-else>
      <i class="fa-solid fa-circle-check text-green-500"></i>
      {{
        $t("labels.days", {
          days: numberWithPrecision(days_until_expiration_date),
        })
      }}
    </span>
    <template v-if="is_suspended">
      <span class="space-actions"></span>
      <badge-default
        :label="$t('model.crop_field_certification.suspended')"
        twBg="bg-red-500"
        twText="text-red-100"
      ></badge-default>
    </template>
  </div>
  <span v-else></span>
</template>

<script>
export default {
  computed: {
    days_until_expiration_date: function () {
      if (this.params.value.length > 0) return this.params.value[0];
      return false;
    },
    is_suspended: function () {
      return this.params.value.includes(
        this.$t("model.crop_field_certification.suspended")
      );
    },
  },
};
</script>

<style>
</style>